<template>
  <div class="container">
    <div class="content-box">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 v-if="plano._id" class>Plano: {{plano.name}}</h3>
              <h3 v-else>Novo Plano</h3>
            </div>
            <div class="col-auto">
              <b-button @click="$router.push({ name: 'EmpresaPlano' })">Voltar</b-button>
              <b-button @click="formEmpresa()">Novo</b-button>
            </div>
          </div>
        </div>
        <div class="element-box">
          <form @submit.prevent="save()">
            <div class="row">
              <div class="col">
                <div class="form-group"
                  :class="{'has-danger': errors.has('name')}">
                  <label for="name">Nome</label>
                  <input
                    id="name"
                    name="name"
                    v-validate="'required'"
                    v-model="plano.name"
                    type="text"
                    class="form-control"
                  />
                  <div
                      v-if="errors.has('name')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('name')}}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group"
                  :class="{'has-danger': errors.has('price')}">
                  <label for="price">Preço (R$)</label>
                  <money
                    required
                    v-model="plano.price"
                    name="price"
                    v-validate="'required'"
                    class="form-control"
                    id="price"
                  />
                  <div
                      v-if="errors.has('price')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('price')}}</div>
                </div>
              </div>
            </div>
            <div class="row" v-if="utilizaVindi">
              <div class="col-md-6">
                <div class="form-group"
                  :class="{'has-danger': errors.has('tipoRecorrencia')}">
                  <label for>Tipo de Recorrência</label>
                  <select id="tipoRecorrencia" name="tipoRecorrencia" v-validate="'required'" v-model="plano.tipoPlano" class="custom-select">
                    <option :value="null">Selecione</option>
                    <option value="Mensal">Mensal</option>
                    <option value="Anual">Anual</option>
                  </select>
                  <div
                      v-if="errors.has('tipoRecorrencia')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('tipoRecorrencia')}}</div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for>Id Plano</label>
                  <input v-model="plano.idPlanoVindi" disabled type="text" class="form-control" />
                </div>
              </div>
            </div>
            <div class="row" v-if="utilizaVindi">
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('valorRepasse')}">
                  <label>Valor Repasse GrupoSin</label>
                  <money
                    required
                    v-model="plano.valorRepasse"
                    name="valorRepasse"
                    v-validate="'required'"
                    class="form-control"
                    id="valorRepasse"
                  />
                  <div
                      v-if="errors.has('valorRepasse')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('valorRepasse')}}</div>
                </div>
              </div>
              <div class="col">
                <div class="form-group" :class="{'has-danger': errors.has('valorImposto')}">
                  <label>Valor Imposto</label>
                  <money
                    required
                    v-model="plano.valorImposto"
                    name="valorImposto"
                    v-validate="'required'"
                    class="form-control"
                    id="valorImposto"
                  />
                  <div
                      v-if="errors.has('valorImposto')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('valorImposto')}}</div>
                </div>
              </div>
            </div>

            <div class="row" v-if="utilizaPagarme">
              <div class="col-md-12">
                <h5>Configuração de SPLIT do plano</h5>
                <hr />
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="pctRepasseDrAchei">% Repasse DrAchei</label>
                  <input class="form-control" id="pctRepasseDrAchei" type="number" min="0" max="100"
                    step=".01"
                    v-model="plano.porcentagemRepasseDrAchei">
                  <small>Valor: {{valorDrAchei | money}}</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="pctRepasseEmpresa">% Repasse {{ empresa.name }}</label>
                  <input class="form-control" id="pctRepasseEmpresa" type="number" min="0" :max="100 - plano.porcentagemRepasseDrAchei"
                    step=".01"
                    v-model="plano.porcentagemRepasseEmpresa">
                  <small>Valor: {{valorEmpresa | money}}</small>
                </div>
              </div>
            </div>

            <div class="row mt-3" v-if="empresa.clube">
              <div class="col">
                <h4>Configuração Clube</h4>
                <hr>
              </div>
            </div>
            <div class="row mb-4" v-if="empresa.clube">
              <div class="col-6">
                <b-form-checkbox
                    switch v-model="plano.viewClube" :unchecked-value="false" :value="true"
                >
                  Disponibilizar plano para o clube(Site)?
                </b-form-checkbox>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col">
                <h4>Dependentes</h4>
                <hr>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-6">
                <b-form-checkbox
                    switch v-model="planoComDependentes" @change="atualizarQtdDependentes"
                  >
                    Deseja disponibilizar dependentes para o plano?
                  </b-form-checkbox>
              </div>
              <div class="col-4">
                <div class="form-group" :class="{'has-danger': errors.has('qtdDependentes')}">
                  <label>Quantidade Dependentes:</label>
                  <input type="number" min="0"
                    required
                    :disabled="!planoComDependentes"
                    v-model="plano.qtdDependentes"
                    name="qtdDependentes"
                    v-validate="'required|min_value:1'"
                    class="form-control"
                    id="qtdDependentes"
                  />
                  <div
                      v-if="errors.has('qtdDependentes')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('qtdDependentes')}}</div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <h4>Taxa de Adesão</h4>
                <hr>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                  <b-form-checkbox
                    switch v-model="cobrarTaxaAdesao" @change="atualizaValor"
                  >
                    Deseja cobrar taxa de adesão
                  </b-form-checkbox>
              </div>
              <div class="col-4">
                <div class="form-group" :class="{'has-danger': errors.has('valorTaxaAdesao')}">
                  <label>Valor Taxa de adesão:</label>
                  <money
                    required
                    :disabled="!cobrarTaxaAdesao"
                    v-model="plano.valorTaxaAdesao"
                    name="valorTaxaAdesao"
                    v-validate="'required|min_value:0.01'"
                    class="form-control"
                    id="valorTaxaAdesao"
                  />
                  <div
                      v-if="errors.has('valorTaxaAdesao')"
                      class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('valorTaxaAdesao')}}</div>
                </div>
              </div>
            </div>
            <div class="row" v-if="utilizaPagarme && cobrarTaxaAdesao">
              <div class="col-md-12">
                <h5>Configuração de SPLIT taxa adesão</h5>
                <hr />
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="taxaAdesaoPctRepasseDrAchei">% Repasse DrAchei</label>
                  <input class="form-control" id="taxaAdesaoPctRepasseDrAchei" type="number" min="0" max="100"
                         step=".01"
                         v-model="plano.taxaAdesaoPorcentagemDrAchei">
                  <small>Valor: {{valorTaxaAdesaoDrAchei | money}}</small>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="taxaAdesaoPctRepasseEmpresa">% Repasse {{ empresa.name }}</label>
                  <input class="form-control" id="taxaAdesaoPctRepasseEmpresa" type="number" min="0" :max="100 - plano.taxaAdesaoPorcentagemDrAchei"
                         step=".01"
                         v-model="plano.taxaAdesaoPorcentagemEmpresa">
                  <small>Valor: {{valorTaxaAdesaoEmpresa | money}}</small>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <h4>Benefícios</h4>
                <hr />
              </div>
            </div>
              <b-form-group>
                <b-form-checkbox
                  switch
                  v-for="option in beneficios"
                  v-model="beneficioSelecteds"
                  :key="option._id"
                  :value="option._id"
                  :name="`beneficio-${option._id}`"
                  :id="`beneficio-${option._id}`">
                {{handleText(option.titulo)}} - {{ handleText(option.descricao) }}
                </b-form-checkbox>
              </b-form-group>
            <div class="row">
              <div class="col">
                <hr>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <b-button variant="primary" type="submit">
                  Salvar
                </b-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .custom-control-label::before{
    border-radius: 4px;
    margin-left: -20px !important;
  }
</style>
<script>
import axios from "axios";

export default {
  computed: {
    empresa () {
      return this.$store.getters.empresa;
    },
    utilizaPlataformaPagamento () {
      return this.empresa && this.empresa.utilizaPlataformaPagamento;
    },
    utilizaVindi() {
      return this.empresa && this.empresa.utilizaPlataformaPagamento && (this.empresa.plataformaPagamento == null
          || this.empresa.plataformaPagamento === 'vindi');
    },
    utilizaPagarme() {
      return this.empresa && this.empresa.utilizaPlataformaPagamento && this.empresa.plataformaPagamento === 'Pagar.me';
    },
    valorDrAchei() {
      if (this.plano.porcentagemRepasseDrAchei && this.plano.price) {
        return this.plano.price * (this.plano.porcentagemRepasseDrAchei / 100);
      }
      return 0;
    },
    valorEmpresa() {
      if (this.plano.porcentagemRepasseEmpresa && this.plano.price) {
        return this.plano.price * (this.plano.porcentagemRepasseEmpresa / 100);
      }
      return 0;
    },
    valorTaxaAdesaoDrAchei() {
      if (this.plano.taxaAdesaoPorcentagemDrAchei && this.plano.valorTaxaAdesao) {
        return this.plano.valorTaxaAdesao * (this.plano.taxaAdesaoPorcentagemDrAchei / 100);
      }
      return 0;
    },
    valorTaxaAdesaoEmpresa() {
      if (this.plano.taxaAdesaoPorcentagemEmpresa && this.plano.valorTaxaAdesao) {
        return this.plano.valorTaxaAdesao * (this.plano.taxaAdesaoPorcentagemEmpresa / 100);
      }
      return 0;
    }
  },
  async created() {
    let id = this.$route.query.id;
    if (id) {
      const response = await axios.get(`/api/plan/id/${id}`);
      this.plano = response.data;
      this.beneficioSelecteds = this.plano.beneficiosPlano
      this.cobrarTaxaAdesao = this.plano.valorTaxaAdesao ? true : false
      this.planoComDependentes = this.plano.qtdDependentes ? true : false
    }

    const responseBeneficio = await axios.get("/api/beneficio");
    this.beneficios = responseBeneficio.data;
  },
  data() {
    return {
      plano: {
        tipoPlano: null,
        porcentagemRepasseDrAchei: 0,
        porcentagemRepasseEmpresa: 0,
        taxaAdesaoPorcentagemDrAchei: 0,
        taxaAdesaoPorcentagemEmpresa: 100,
        viewClube: false
      },
      beneficios: [],
      beneficioSelecteds: [],
      cobrarTaxaAdesao: false,
      planoComDependentes: false
    };
  },
  methods: {
    save() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.$store.dispatch('setLoading', true);
          this.plano.beneficiosPlano = this.beneficioSelecteds;

          if (this.utilizaPagarme) {
            this.plano.tipoPlano = 'Mensal';

            let totalRepasse = Number(this.plano.porcentagemRepasseDrAchei) + Number(this.plano.porcentagemRepasseEmpresa);
            if (totalRepasse !== 100) {
              alert('A porcentagem de SPLIT precisa ser igual a 100%')
              this.$store.dispatch('setLoading', false);
              return false;
            }
          }

          axios.post(`/api/juridica/${this.empresa._id}/plansInsert`, this.plano)
            .then((response) => {
              this.$store.dispatch('setLoading', false);
              if (response.status === 200) {
                this.$router.push({name: 'EmpresaPlano', query: {empresa: this.empresa._id}});
              }
            });
        }
      });
    },
    atualizaValor(value) {
      if (!value) {
        this.plano.valorTaxaAdesao = 0;
      }
    },
    atualizarQtdDependentes(value){
      if (!value) {
        this.plano.qtdDependentes = 0;
      }
    },
    handleText(text) {
      return text.replace('${empresa.name}', this.empresa.name);
    }
  }
};
</script>
